export default "__VITE_ASSET__BTULgM1s__"